export default function Monogram({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 64 64" fill="none" className={className} aria-label="Ayan Jafri monogram" role="img">
      <defs>
        <linearGradient id="aj-g" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF3B30" />
          <stop offset="0.55" stopColor="#8E2DE2" />
          <stop offset="1" stopColor="#00F2FE" />
        </linearGradient>
      </defs>
      <rect x="1.5" y="1.5" width="61" height="61" rx="14" fill="#0E0E12" stroke="url(#aj-g)" strokeOpacity="0.6" strokeWidth="2.5" />
      <path d="M12 45 L23 19 L34 45" stroke="url(#aj-g)" strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17 35.5 H29" stroke="url(#aj-g)" strokeWidth="3.6" strokeLinecap="round" />
      <path d="M50 19 V36 a7.5 7.5 0 0 1 -15 0" stroke="url(#aj-g)" strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
